export default __webpack_public_path__ + "static/media/Catalogue.e2cde381.svg";